import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

// getLogAcceso lo resuelve el authGuard y ajustarLogAcceso ya regresa al login por su cuenta.
const SIN_REDIRECCION = ['/auth/getLogAcceso', '/auth/ajustarLogAcceso'];

export const sesionExpiradaInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  return next(req).pipe(
    catchError((err: unknown) => {
      const es401 = err instanceof HttpErrorResponse && err.status === 401;
      const exento = SIN_REDIRECCION.some((ruta) => req.url.includes(ruta));
      if (!es401 || exento) return throwError(() => err);

      auth.irAlLogin();
      return EMPTY;
    }),
  );
};
